var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.968,
    height: 22.265,
    viewBox: "0 0 20.968 22.265",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M171.065,79.006a5.068,5.068,0,0,1,.375-1.916,5.016,5.016,0,0,1,1.07-1.624,4.89,4.89,0,0,1,6.98,0,5.016,5.016,0,0,1,1.07,1.624,5.066,5.066,0,0,1-1.07,5.456,4.887,4.887,0,0,1-6.98,0A5.045,5.045,0,0,1,171.065,79.006Zm-4.431,11.411a4.448,4.448,0,0,1,1.276-3.123A5.335,5.335,0,0,1,171.4,86h.4a2.042,2.042,0,0,1,.631.1l1.006.333a8.307,8.307,0,0,0,5.226,0l1.006-.333a2.006,2.006,0,0,1,.63-.1h.4a5.714,5.714,0,0,1,3.634,1.294,4.449,4.449,0,0,1,1.276,3.123v1.4a1.8,1.8,0,0,1-1.5,1.787,51.988,51.988,0,0,1-15.972,0,1.782,1.782,0,0,1-1.073-.614,1.828,1.828,0,0,1-.425-1.173Z",
    transform: "translate(-165.634 -73)",
    fill: "none",
    stroke: "#ff5d00",
    strokeWidth: 2,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.3f85b9536819739da0e3bb3d462610d6.svg";
export { ForwardRef as ReactComponent };